<template>
  <button><slot></slot></button>
</template>

<script>
export default {
  name: 'app-button'
}
</script>

<style lang="scss" scoped>
 button {
   background: red;
 }
</style>



// WEBPACK FOOTER //
// Button.vue?37450d7c